import { DialogTitle, Divider, IconButton } from "@mui/material"
import { CloseOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React from "react"

const DialogHeader: FC<{
  title: string
  onClose: () => void
}> = ({ title, onClose }) => {
  return (
    <>
      <DialogTitle className='pl-10 font-normal text-primary'>{title}</DialogTitle>
      <IconButton aria-label='close' onClick={onClose} className='absolute right-4 top-3 text-primary'>
        <CloseOutlined />
      </IconButton>
      <Divider />
    </>
  )
}

export default DialogHeader
